import { Link, useLocation } from "react-router-dom";
import { Compass, Award, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicNav from "@/components/PublicNav";

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-[#D6D3D1] text-zinc-900">
      <PublicNav />
      <main className="max-w-xl mx-auto px-5 py-16 text-center">
        <Compass className="h-12 w-12 mx-auto text-[#5EA529] mb-4" />
        <h1 className="font-mono text-3xl font-bold tracking-tighter text-black">
          404 — Página no encontrada
        </h1>
        <p className="mt-3 text-sm text-zinc-700 font-mono break-all">
          <code className="bg-white px-2 py-0.5 rounded-sm border border-zinc-400">
            {pathname}
          </code>
        </p>
        <p className="mt-4 text-sm text-zinc-700 leading-relaxed">
          La dirección solicitada no existe. Usa uno de los siguientes destinos:
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2">
          <Link to="/">
            <Button
              data-testid="notfound-home-btn"
              className="bg-[#5EA529] hover:bg-[#4f8c22] text-white rounded-sm"
            >
              <Award className="h-4 w-4 mr-2" /> Diplomas activos
            </Button>
          </Link>
          <Link to="/admin/login">
            <Button
              data-testid="notfound-admin-btn"
              variant="outline"
              className="border-zinc-500 bg-white hover:bg-zinc-100 text-black rounded-sm"
            >
              <LogIn className="h-4 w-4 mr-2" /> Panel Admin
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
